import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Url } from "../Url";

@Injectable({ providedIn: "root" })
export class UsersService {
  private apiUrl = Url;

  constructor(private httpClient: HttpClient) {}

  /**
   * Seen-state of the first-run welcome modal. `welcome_seen_at` is null until
   * the user dismisses the modal. Used on bootstrap to decide whether to show
   * it (fetched fresh rather than read from the JWT, which would go stale).
   */
  getWelcomeSeen(): Observable<{ welcome_seen_at: string | null }> {
    return this.httpClient.get<{ welcome_seen_at: string | null }>(
      `${this.apiUrl}/users/me/welcome-seen`,
    );
  }

  /**
   * Mark the first-run welcome modal as seen for the authed user. Idempotent on
   * the backend (only stamps `welcome_seen_at` the first time). Called when the
   * welcome modal is dismissed so we know the user has seen it.
   */
  markWelcomeSeen(): Observable<{ welcome_seen_at: string }> {
    return this.httpClient.patch<{ welcome_seen_at: string }>(
      `${this.apiUrl}/users/me/welcome-seen`,
      {},
    );
  }
}
